import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=5fc0db9c&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=ts"
export * from "./Paginator.vue?vue&type=script&lang=ts"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=5fc0db9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0db9c",
  null
  
)

export default component.exports